module.exports = __webpack_public_path__ + "img/honor3.8aef138e.png";